import type { ActivePurchaseType } from './activePurchases.types'
import type { InactivePurchaseType } from './inactivePurchases.types'

export const enum DeliveryMethods {
	dropPoint = 'droppoint_delivery',
	home = 'home_delivery',
	store = 'store_delivery',
}

export const enum StatusLines {
	outOfStock = 'outOfStock',
	available = 'available',
}

export type PossibleOrders = ActivePurchaseType[] | InactivePurchaseType[]

export type GetPurchaseProps = {
	token: string
	languageISO: string
	countryISO: string
	channel: string
}

export type DeliveryType = {
	fullName: string
	fullAddress: string
	zipCode: string
	city: string
	phoneNumber: string
	email: string
}

export enum OrderStatus {
	created = 'created',
	in_preparation = 'in_preparation',
	ready = 'ready',
	shipped = 'shipped',
	cancelled = 'cancelled',
	rejected = 'rejected',
	on_delivery = 'on_delivery',
	denied = 'denied',
	in_store = 'in_store',
	in_droppoint = 'in_droppoint',
	on_international_transit = 'on_international_transit',
	annulled = 'annulled',
	cancellation_in_progress = 'cancellation_in_progress',
}
